/**
 * All HTML content generated by WordPress needs to be scrubbed to
 * make sure links and srouces are targeting the frontend, not the WP server.
 *
 * @param {String} content HTML content string from WordPress
 */

// See: https://gitlab.com/FathomCompany/ringdna-brandsite/issues/12
export const parseHTML = content => {
    if (!content) return "";

    // wp-content assets are always served from WordPress, not the frontend
    content = content.replace(/src="(\/wp-content\/)/g, `src="${process.env.WORDPRESS_URL}$1`);

    // All other relative sources use the frontend domain
    content = content.replace(/src="\//g, `src="${process.env.SITE_URL}/`);

    // Set all links from the WordPress domain to use the Frontend domain
    const linkRegex = new RegExp(`href="${process.env.WORDPRESS_URL}`, "g");
    content = content.replace(linkRegex, `href="`);

    // Strip unrendered shortcodes from content
    content = content.replace(/\[\/?.*?\]/g, "");

    return content;
};
